import { Facet, GroupedFacet } from 'common/types/search-response';

export const isGroupedFacet = (facet: Facet): facet is GroupedFacet => !('id' in facet.values[0]);

export const findFacetValue = (facet: Facet, valueId: string) => {
  if (!isGroupedFacet(facet)) return facet.values.find((v) => v.id === valueId);

  // eslint-disable-next-line no-restricted-syntax
  for (const group of facet.values) {
    // eslint-disable-next-line no-restricted-syntax
    for (const facetValue of group.items) {
      if (facetValue.id === valueId) return facetValue;
    }
  }

  return undefined;
};
